/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { useTranslations } from 'next-intl'
import React from 'react'

import { RegionSelect } from '@/components/ui/RegionSelect'

/**
 * A select element to choose a region. Designed to be used in the desktop header.
 */
const HeaderRegionSelect: React.FC = () => {
  const t = useTranslations('RegionSelect')
  return (
    <RegionSelect
      aria-label={t('headerLabel')}
      className={'bg-primary-500 text-white uppercase text-xs max-w-64 text-ellipsis'}
    />
  )
}

export { HeaderRegionSelect }
